export class LabelIT {

  public static required: string;
  public static incorrect: string;

  public static TROVA_ATM = class {
    public static LABEL: any = {
      atmTabLabel: "ATM",
      agenzieTabLabel: "AGENZIE",
      titleBarTitle: 'Dove siamo',
      titleBarSubtitle: ' ',
      titleBarMenuTitle: ' ',
      agenzieHeader: "Cerco un' Agenzia in",
      atmHeader: "Cerco un ATM in",
      regionSelectLabel: "quale Regione?",
      provinceHeader: "In provincia di",
      provinceSelectLabel: "Tutte le Province",
      selezionaLabel: 'Tutte le Province',
      searchButtonLabel: "CERCA",
      getCurrentLocationLabel: "IMPOSTA LA TUA POSIZIONE",
      resultsFoundLabel: "Risultati trovati",
      agencyResultTitle: "Centri Clienti",
      detailButtonLabel: "DETTAGLI",
      goBackLabel: "Torna indietro",
      lookOnGoogleMapLabel: "Guarda su google maps",
      atmResultTitle: "ATM",
      serviceLabel: "Servizi disponibili: ",
      filterByServiceLabel: "Filtra i servizi",
      filterLabel: "FILTRA",
      service1Label: "Prelievo",
      service2Label: "Saldo e movimenti",
      service3Label: "Ricariche telefoniche",
      service4Label: "Ricarica carta",
      service5Label: "Bonifici e giroconti",
      service6Label: "Pagamento bollettini postali",
      service7Label: "Versamento banconote e assegni",
      valueRequiredMessage: "Il valore è richiesto",
    };

    public static MESSAGES: any = {};
  }

  //Accesso ai messaggi
  public static getMessage(className, field, required, incorrect, value): string {
    this.setRequired("");
    this.setIncorrect("");

    if (required) {
      this.setRequired(value);
    } else if (incorrect) {
      this.setIncorrect(value);
    }
    return LabelIT[className].MESSAGES[field] || "MESSAGE NON TROVATO";
  }

  //Accesso alle label
  public static getLabel(className, field): string {
    return LabelIT[className].LABEL[field] || "LABEL NON TROVATO";
  }

  static setRequired(nameField) {
    LabelIT.required = nameField;
  }

  static setIncorrect(nameField) {
    LabelIT.incorrect = nameField;
  }
}
